import { FC } from 'react'
//components
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import {
  isInViewFooterState,
  stepState,
  productsState,
  selectedProductState,
  inquiryState,
} from '../../../states/messageState'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { useRequestFailed } from '../../../hooks/useRequestFailed'
import { Slider } from '../../Slider'
import { format, isAfter, parseISO } from 'date-fns'
import { Product as ProductType } from '../../../models/contractsModel'
import { Product } from '../../Product'

export const ChooseProduct: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const { requestFailed } = useRequestFailed()

  const products = useRecoilValue(productsState)

  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setSelectedProduct = useSetRecoilState(selectedProductState)
  const setCurrentStep = useSetRecoilState(stepState)
  const setInquiry = useSetRecoilState(inquiryState)

  /**商品を選択 */
  const handleClickProduct = async (product: ProductType) => {
    setIsInViewFooter(false)
    const { id: contractId, productTitle, planTitle, isFulfilled } = product

    const transactionDate = format(parseISO(product.transactionDate), 'yyyy年MM月dd日')
    const endedAt = format(parseISO(product.endedAt), 'yyyy年MM月dd日')
    const startedAtStr = format(parseISO(product.startedAt), 'yyyy年MM月dd日')
    await handleAddSenderParent('user', `${transactionDate}に購入した${productTitle}です`)

    //保証履行済みの商品を選択した場合、申請できないようにする
    if (isFulfilled) {
      requestFailed(true)
      return
    }

    //保証履行済み出ない場合、申請を進める
    const startedAt = parseISO(product.startedAt)
    //Y/M/D 00:00にする
    const startedAtBeginning = new Date(startedAt.getFullYear(), startedAt.getMonth())
    const isStartedContract = isAfter(new Date(), startedAtBeginning)
    setSelectedProduct(product)
    if (isStartedContract) {
      //適用可能なら保証タイプをセット
      setInquiry((prev) => ({ ...prev, contractId }))
      await handleAddSenderParent('bot', `見つかりました。${productTitle}で${planTitle}を購入したようです`)
      await handleAddMessage('bot', `正常に機能しなくなったのはいつですか？`)
      handleInViewFooter()
      setCurrentStep('inputDate')
    } else {
      await handleAddSenderParent(
        'bot',
        `申し訳ございません。\n現在はproteger延長保証期間内ではございません。\n保証期間は${startedAtStr}から${endedAt}です。\nさらなるお問い合わせが必要な場合は\ncustomer@helloproteger.comへお問い合わせ下さい。`
      )
      handleInViewFooter()
      setCurrentStep('beforePlanStart')
    }
  }

  /**商品がなかった */
  const handleClickNotProduct = async () => {
    setIsInViewFooter(false)
    await handleAddSenderParent('user', 'こちらではありません')
    await requestFailed()
  }

  return (
    <FooterContent isWide>
      <Slider>
        {products.map((product, index) => (
          <Product product={product} key={`${product.id}_${index}`} onClick={() => handleClickProduct(product)} />
        ))}
        <Product product={null} onClick={handleClickNotProduct} />
      </Slider>
    </FooterContent>
  )
}
